import React from "react";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import { useAtom } from "jotai";
import { themeAtom } from "../../../../-Atoms";
import UniversalTextField from "../../../../GlobalComponents/UniversalTextField";

const CommentsImagesScheduledContainer = ({ jobData, setHasUnsavedChanges }) => {
  const [theme] = useAtom(themeAtom);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
        staggerChildren: 0.05,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.25, 0.1, 0.25, 1.0],
      },
    },
    hover: { scale: 1.02 },
    tap: { scale: 0.98 },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "100%",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor:
          theme === "dark" ? "rgba(35,35,35,0.7)" : "rgba(235,235,235,0.9)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        boxShadow:
          theme === "dark"
            ? "0 2px 10px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 2px 10px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.5)",
        padding: 2,
        my: 2,
      }}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants}>
          <UniversalTextField
            collectionName="JobData"
            docId={jobData.id}
            fieldName="comments"
            value={jobData.comments || ""}
            label="Comments"
            setHasUnsavedChanges={setHasUnsavedChanges}
            adminOnly={true}
            sx={{ marginTop: 0 }}
          />
        </motion.div>
        
        <motion.div variants={itemVariants}>
          <UniversalTextField
            collectionName="JobData"
            docId={jobData.id}
            fieldName="imagesScheduledToBeShot"
            value={jobData.imagesScheduledToBeShot || ""}
            label="Images Scheduled"
            setHasUnsavedChanges={setHasUnsavedChanges}
            adminOnly={true}
            sx={{ marginTop: 1 }}
          />
        </motion.div>
      </motion.div>
    </Box>
  );
};

export default CommentsImagesScheduledContainer;
